<template>
  <b-col :class="{ card: showInCard}" class="contact">
    <div>
      <p>{{ inlineMessage }} <a v-b-modal="modalId">{{ inlineLink }}</a></p>
    </div>
    <b-modal :id="modalId"
             modal-class="contact-modal"
             centered
             hide-header
             footer-class="contact-modal-footer"
             :title="modalHeading"
             @ok="submitForm"
             @cancel="closeForm"
             v-model="show">
      <h4 v-html="modalHeading"></h4>
      <p>{{ modalText }}</p>
      <b-form-textarea class="contact-textarea"
                       :placeholder="modalInputPlaceholder"
                       no-resize
                       rows="8"
                       v-model="message"></b-form-textarea>
      <template v-slot:modal-footer>
        <b-button variant="secondary"
                  size="sm"
                  @click="closeForm()">
          {{ cancelBtn }}
        </b-button>
        <b-button variant="primary"
                  size="sm"
                  @click="submitForm()">
        {{ submitBtn }}
        </b-button>
      </template>
    </b-modal>
  </b-col>
</template>

<script>
import $store from '@/store/index'
export default {
  props: {
    showInCard: {
      type: Boolean,
      default: false
    },
    inlineMessage: {
      type: String
    },
    inlineLink: {
      required: true,
      type: String
    },
    modalHeading: {
      required: true,
      type: String
    },
    modalText: {
      required: true,
      type: String
    },
    modalInputPlaceholder: {
      type: String,
      default: 'Enter Message Here'
    },
    submitBtn: {
      type: String,
      default: 'Submit'
    },
    cancelBtn: {
      type: String,
      default: 'Cancel'
    },
    modalId: {
      required: true,
      type: String
    },
    submitEvent: {
      required: true,
      type: String
    },
    cancelEvent: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      show: false,
      message: ''
    }
  },
  methods: {
    async submitForm () {
      await $store.dispatch('customer/sendForm', this.message)
      this.show = false
      this.message = ''
    },
    closeForm (modal) {
      this.show = false
      this.$ea.trackEvent({
        type: this.cancelEvent
      })
    }
  }
}
</script>

<style lang="scss">
.contact {
  margin: 0 0 1em;
  p {
    margin: 0.6em;
  }
  a {
    color: #212529;
    font-weight: bold;
    cursor: pointer;
  }
}
.contact-modal {
  text-align: center;
  .modal-body {
    border-top: 8px solid $color-heading-text;
  }
  .contact-textarea {
    padding: 1.25em;
    border: 2px solid $input-border-color;
    background-color: $color-body-bg;
    color: $input-color;
  }
  .contact-modal-footer {
    border: none;
    .btn-secondary,
    .btn-primary {
      display: inline-block;
      width: 50%;
    }
    .btn-secondary {
      background-color: transparent;
      border-color: transparent;
      color: $color-heading-text;
      font-size: 1.25em;
    }
    .btn-primary {
      background-color: $color-heading-text;
      border-color: $color-heading-text;
      font-size: 1.25em;
    }
  }
}
</style>
